import i18n from 'i18next';

const serviceToModuleMap = {
  seo: { value: 'seo', label: 'SEO' },
  content: { value: 'content', label: i18n.t('Content') },
  paidMedia: { value: 'paidMedia', label: i18n.t('PaidMedia') },
};

export { serviceToModuleMap };
